import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import FreeTag from 'container/components/FreeTag/FreeTag';
import Promps from 'container/components/Promps/Promps';
import UpgradeButton from 'container/components/UpgradeButton/UpgradeButton';
import assets from 'assets';

const User = ({ isMobile, setLogoutModal }) => {
  const navigate = useNavigate();
  const userData = useSelector(state => state.auth.user);
  const isDark = useSelector(state => state.utils.isDarkMode);

  const { isLoggedIn } = useSelector(state => state.auth);
  const handleSettings = () => {
    const params = new URLSearchParams(window.location.search);
    navigate(`/settings/profile/?${params.toString()}`);
  };

  return (
    <Container isDark={isDark}>
      <div
        // style={{
        //     width: isMobile ? window.outerWidth : '',
        // }}
        className={`${!isMobile && 'desktop '}  dropdown flex flex-column`}
      >
        <div className='user-detail flex flex-column gap-10 '>
          <div className='flex gap-2 align-items-center'>
            <img
              src={userData?.profile?.profile_image || assets.mainLogo}
              alt='user data'
              className='user-image'
              width={24}
              height={24}
            />
            <span className='username'>
              {isLoggedIn == null
                ? 'New User'
                : userData?.first_name || userData?.username}
            </span>
          </div>

          <div className='flex align-items-center justify-content-between'>
            <Promps />
            <FreeTag />
          </div>

          <div>
            <UpgradeButton />
          </div>
        </div>

        <Divider />

        <div className='user-detail flex flex-column gap-1'>
          <div onClick={handleSettings} className='item align-items-center'>
            {/* <img src={assets.profileCircle} width={20} height={20} alt='' /> */}
            <assets.newProfileCircle className='svg-icon' />
            <span>Profile</span>
          </div>

          <div onClick={handleSettings} className='item align-items-center'>
            {/* <img src={assets.hashTag} width={20} height={20} alt='' /> */}
            <assets.newSettings className='svg-icon-stroke' />
            <span>Account Settings</span>
          </div>

          <div
            onClick={() =>
              window.open(
                'https://www.flexoffers.com/affiliate-programs/chatai-affiliate-program/',
                '_blank'
              )
            }
            className='item align-items-center'
          >
            {/* <img src={assets.affiliates} width={20} height={20} alt='' /> */}
            <assets.newUserThree className='svg-icon' />
            <span>Affiliates</span>
          </div>

          <div
            onClick={() => setLogoutModal(true)}
            className='item align-items-center'
          >
            <assets.newLogout className='svg-icon' />
            <span>Log out</span>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default User;

const Container = styled.div`
  color: white;

  /* & .prompt-container{
        background: ${({ isDark }) =>
    isDark && 'rgba(126, 63, 228, 1) !important'} ;
        -webkit-background-clip: ${({ isDark }) =>
    isDark && 'text !important'} ;
        -webkit-text-fill-color: ${({ isDark }) =>
    isDark && 'transparent !important'} ;
        background-clip: ${({ isDark }) => isDark && 'text !important'} ;
        text-fill-color: ${({ isDark }) => isDark && 'transparent !important'} ;
    } */

  & .desktop {
    position: fixed;
    bottom: 0;
    left: 0;
    transform: translate(10%, -20%);
    width: 267px;
    height: max-content;
    /* height: 267px; */
    /* z-index: 999999 !important; */
  }

  & .svg-icon path {
    fill: ${({ isDark }) =>
      isDark ? 'rgba(255, 255, 255, 1)' : 'rgba(32, 33, 36, 1)'};
  }

  & .svg-icon-stroke path {
    stroke: ${({ isDark }) =>
      isDark ? 'rgba(255, 255, 255, 1)' : 'rgba(32, 33, 36, 1)'};
  }

  & .dropdown {
    border-radius: 8px;
    border: 1px solid
      ${({ isDark }) =>
        isDark
          ? 'var(--new-dark-color-border)'
          : 'var(--new-light-color-border)'};
    /* background-color: #35363A; */
    background-color: ${({ isDark }) =>
      isDark ? 'var(--new-dark-color)' : 'var(--new-light-color)'};
    z-index: 25;

    & .username {
      font-size: 16px;
      line-height: 23.2px;
      font-weight: 600;
      font-family: Poppins;
      color: ${({ isDark }) => (isDark ? '#FFFFFF' : 'var(--new-dark-color)')};
    }

    & .user-detail {
      padding: 10px;
    }

    & .gap-10 {
      gap: 10px;
    }

    & .item {
      display: flex;
      gap: 10px;
      padding: 8px 0px;
    }

    & .item span {
      font-size: 14px;
      line-height: 20.3px;
      font-weight: 400;
      color: ${({ isDark }) => (isDark ? '#FFFFFF' : 'var(--new-dark-color)')};
    }
  }
`;

const Divider = styled.div`
  border-top: 1px solid
    ${({ isDark }) =>
      isDark
        ? 'var(--new-dark-color-border)'
        : 'var(--new-light-color-border)'};
  margin-block: -2px;
`;
